import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";

import DropdownContainer from "@devices/components/shared/Dropdown/DropdownContainer";

const useStyles = makeStyles()((theme) => ({
    row: {
        display: "flex",
        alignItems: "flex-end",
        gap: theme.spacing(1),
    },
    selector: {
        flex: 1,
        // Without this a long option label stretches the flex item and pushes the menu button off the row.
        minWidth: 0,
    },
}));

type Props = React.PropsWithChildren<{
    selector: React.ReactNode;
    disabled?: boolean;
}>;

/**
 * The selector plus manage-menu header used by every page that picks one entity and then acts on it
 * (policies, products, provisioning). The select field goes in `selector`; the create / rename /
 * import / export / delete entries are the `DropdownItem` children.
 *
 * The items have to stay direct children: MUI's `MenuList` assigns `role="menuitem"` by walking its
 * own children, so wrapping them in a fragment leaves them unreachable by role.
 */
export const EntityManagerRow = ({ children, selector, disabled }: Props) => {
    const { classes } = useStyles();
    const { t } = useTranslation(["common"]);
    const anchorRef = React.useRef<HTMLButtonElement>(null);

    return (
        <div className={classes.row}>
            <div className={classes.selector}>{selector}</div>
            <DropdownContainer
                icon={<i className="fa-solid fa-gear" />}
                anchorRef={anchorRef}
                disabled={disabled}
                tooltipProps={{ title: t("common:button.manage") }}
            >
                {children}
            </DropdownContainer>
        </div>
    );
};
